import React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import theme from '../../../styles/PageTheme';
import styles from '../../../styles/PageStyles.js';

const LinearIndeterminateProgress = (props) => {
    const classes = styles(theme);
    const { displayProgress } = props;

    if (!displayProgress) {
        return null;
    }
    return (
        <Box sx={classes.linearInderminateProgress} elevation={6}>
            <LinearProgress aria-live="assertive" aria-label="Looking up member" />
        </Box>
    );
};

export default LinearIndeterminateProgress;
